/**
 * Omnisend Custom Trigger – Plopping-Flow (50 €), mit Upcart-Cart-Close-Handling
 *
 * Bedingungen (nur wenn mind. ein Produkt mit Tag "plopping-product" im Cart ist):
 *  - UNDER:   subtotal < 50 €  -> Popup A, max. 1x alle 30s
 *              + Sonderfall: beim Cart-Schließen einmal sofort wieder öffnen.
 *  - REACHED: subtotal >= 50 € -> Popup B, genau 1x pro Session
 */

(function () {
  // === CONFIG ===
  const FORM_UNDER_ID   = '68f4de0301523e4b1cb37f8b';    // Popup A (unter 50 €)
  const FORM_REACHED_ID = '691989840e3326f898b173d0';    // Popup B (Gratulation)
  const QUALIFYING_TAG  = 'plopping-product';
  const THRESHOLD_CENTS = 5000; // 50 €

  const RECHECK_MS        = 1500;   // Polling-Intervall
  const UNDER_COOLDOWN_MS = 30000;  // 30s Cooldown für Popup A

  // Session-Keys
  const SS_UNDER_LAST_OPEN_AT = 'omni_plopping_under_last_open_at';
  const SS_REACHED_SHOWN      = 'omni_plopping_reached_shown';

  // Upcart-spezifische Selektoren für Cart-Close
  const CART_CLOSE_SELECTORS = [
    '.upcart-header-close-button',  // offizieller Upcart Close-Button
    '.upcart-backdrop',             // Klick auf den dunklen Hintergrund
    '[data-upcart-close]',          // Fallback
    '.UpCart__Close',
    '.upcart-close',
    '.cart-drawer__close',
    '.drawer__close',
    '.cart-drawer-close'
  ];

  let lastState = 'NONE';
  let pollTimer = null;
  const tagCache = new Map();
  const log = (...a) => { try { console.debug('[omni-plopping]', ...a); } catch (_) {} };

  // ---- z-index Fix (Popup oben, ohne pointer-events-Hacks) ----
  (function injectCssFix() {
    const css = `
      .omnisend-popup, .omnisend-modal, .omnisend-form {
        z-index: 2147483646 !important;
      }
    `;
    const style = document.createElement('style');
    style.appendChild(document.createTextNode(css));
    document.head.appendChild(style);
  })();

  // ---- Helpers ----
  function now() { return Date.now(); }
  function ssSet(key, val) { sessionStorage.setItem(key, String(val)); }
  function ssGet(key) { return sessionStorage.getItem(key); }
  function ssHas(key) { return sessionStorage.getItem(key) === '1'; }

  function getUnderLastOpen() {
    return Number(ssGet(SS_UNDER_LAST_OPEN_AT) || 0);
  }

  function canOpenUnder() {
    const last = getUnderLastOpen();
    if (!last) return true; // noch nie geöffnet
    return (now() - last) >= UNDER_COOLDOWN_MS;
  }

  function markUnderOpened() {
    ssSet(SS_UNDER_LAST_OPEN_AT, now());
  }

  async function fetchJSON(url) {
    const res = await fetch(url, { credentials: 'same-origin' });
    if (!res.ok) throw new Error(`HTTP ${res.status} @ ${url}`);
    return res.json();
  }

  async function fetchCart() {
    return fetchJSON('/cart.js');
  }

  async function productHasTag(handle, tag) {
    if (!handle) return false;
    if (tagCache.has(handle)) return tagCache.get(handle);
    try {
      const data = await fetchJSON(`/products/${handle}.js`);
      const tags = Array.isArray(data.tags)
        ? data.tags
        : String(data.tags || '').split(',').map(t => t.trim());
      const ok = tags.includes(tag);
      tagCache.set(handle, ok);
      return ok;
    } catch (e) {
      tagCache.set(handle, false);
      log('productHasTag error', handle, e);
      return false;
    }
  }

  async function cartContainsTag(cart, tag) {
    const handles = [...new Set((cart.items || []).map(i => i.handle).filter(Boolean))];
    for (const h of handles) {
      if (await productHasTag(h, tag)) return true;
    }
    return false;
  }

  function omniOpen(formId, tries = 10) {
    const go = () => {
      try {
        window.omnisend = window.omnisend || [];
        window.omnisend.push(['openForm', formId]);
        log('openForm', formId);
      } catch (e) {
        if (tries > 0) setTimeout(() => omniOpen(formId, tries - 1), 200);
      }
    };
    setTimeout(go, 0);
  }

  // Popup A – normaler Aufruf (mit Cooldown)
  function maybeOpenUnder() {
    if (!canOpenUnder()) {
      log('UNDER cooldown active, not opening');
      return;
    }
    omniOpen(FORM_UNDER_ID);
    markUnderOpened();
    log('UNDER opened (normal)');
  }

  // Popup A – erzwungen nach Cart-Schließen (ignoriert Cooldown EINMAL)
  function forceOpenUnderAfterCartClose() {
    omniOpen(FORM_UNDER_ID);
    markUnderOpened(); // ab jetzt gilt wieder normaler Cooldown
    log('UNDER opened (forced after cart close)');
  }

  // Popup B – 1x pro Session
  function maybeOpenReached() {
    if (ssHas(SS_REACHED_SHOWN)) {
      log('REACHED already shown this session');
      return;
    }
    omniOpen(FORM_REACHED_ID);
    ssSet(SS_REACHED_SHOWN, '1');
    log('REACHED opened (first time this session)');
  }

  // ---- MAIN EVALUATION ----
  async function evaluate() {
    try {
      const cart = await fetchCart();
      const subtotal = cart.items_subtotal_price || 0;
      const hasTag = await cartContainsTag(cart, QUALIFYING_TAG);

      if (!hasTag) {
        lastState = 'NONE';
        return;
      }

      if (subtotal < THRESHOLD_CENTS) {
        // UNDER
        if (lastState !== 'UNDER') {
          lastState = 'UNDER';
          maybeOpenUnder();
        } else {
          // Zustand bleibt UNDER – normal weiter versuchen (Cooldown schützt vor Spam)
          maybeOpenUnder();
        }
        return;
      }

      // REACHED
      if (lastState !== 'REACHED') {
        lastState = 'REACHED';
        maybeOpenReached();
      }
      // Wenn REACHED schon aktiv ist, nichts weiter tun.
    } catch (e) {
      log('evaluate error', e);
    }
  }

  function startPolling() {
    if (pollTimer) return;
    pollTimer = setInterval(() => evaluate(), RECHECK_MS);
  }

  // ---- Hooks für Cart-Changes ----
  const _fetch = window.fetch;
  window.fetch = function () {
    const args = arguments;
    const req = args[0];
    const url = (typeof req === 'string') ? req : (req && req.url) || '';
    const mut = /\/cart\/(add|update|change)(\.js)?/.test(url);
    return _fetch.apply(this, args).then(resp => {
      if (mut) setTimeout(() => evaluate(), 400);
      return resp;
    });
  };

  document.addEventListener('submit', e => {
    const f = e.target;
    if (f && f.action && /\/cart\/(add|update|change)/i.test(f.action)) {
      setTimeout(() => evaluate(), 600);
    }
  }, true);

  // ---- Cart-Close-Erkennung -> Under-Popup einmal „force“ ----
  document.addEventListener('click', e => {
    const t = e.target;
    if (!t || !t.closest) return;
    const selector = CART_CLOSE_SELECTORS.join(',');
    const closeBtn = t.closest(selector);
    if (!closeBtn) return;

    log('Cart close detected via', closeBtn.className || closeBtn);

    // wir warten kurz, bis der Drawer wirklich zu ist
    setTimeout(() => {
      if (lastState === 'UNDER') {
        forceOpenUnderAfterCartClose();
      }
    }, 400);
  }, true);

  document.addEventListener('DOMContentLoaded', () => {
    startPolling();
    evaluate();
  });
})();
